import { render, staticRenderFns } from "./ParkingLog.vue?vue&type=template&id=00afa96a&scoped=true&"
import script from "./ParkingLog.vue?vue&type=script&lang=js&"
export * from "./ParkingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afa96a",
  null
  
)

export default component.exports